import Logo from '@/components/common/Logo'
import Link from 'next/link'
import { useRouter } from 'next/router'

interface FooterLink {
  label: string
  href: { pathname: string; query: any; }
}

interface FooterColumn {
  title: string
  titleHref?: { pathname: string; query: any; }
  links: FooterLink[]
}

interface FatFooterProps {
  columns: FooterColumn[]
}

export const FatFooter: React.FC<FatFooterProps> = ({ columns }) => {
  const router = useRouter()
  const currentPath = router.pathname

  return (
    <footer className='site-footer bg-[#111821] py-[56px] font--accent relative overflow-hidden'>
      <div className='gradient-circle top-[-400px] left-[-400px] w-[1500px] h-[1500px]'></div>
      <div className='container !max-w-[1320px]'>
        <Logo className='logo--primary inline-block' link={'/'} color={'white' }/>
        <div className='md:flex mt-[56px] md:mt-[72px] flex-wrap'>
          {columns.map((col, colIdx) => (
            <div className="md:w-[50%] xl:w-[33.33333%]" key={colIdx}>
              <h6 className="text-white text-[20px] font-semibold mb-[24px]">
                {col.titleHref ? (
                  <Link href={col.titleHref} passHref><a className='underline hover:no-underline'>{col.title}</a></Link>
                ) : (
                  col.title
                )}
              </h6>
              <ul className="mb-[48px] md:mb-[64px]">
                {col.links.map((link, linkIdx) => (
                  <li className={
                    `mb-[16px] opacity-90${linkIdx === col.links.length - 1 ? '' : ''} ${currentPath === link.href.pathname ? 'opacity-100 color-secondary' : ''}`
                  } key={linkIdx}>
                    <Link href={link.href}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className='mt-[10px] opacity-70 flex flex-col md:flex-row md:justify-between'>
          <p className='mb-[26px] xl:mb-[16px]'>Commit Action © {(new Date).getFullYear()} - All Rights Reserved.</p>
          <div className='flex flex-wrap gap-x-[20px] xl:gap-x-[40px]'>
            <div className='mb-[10px] xl:mb-[0px]'>
              <Link href={'/contact'}>Contact</Link>
            </div>
            <div className={`mb-[10px] xl:mb-[0px] ${currentPath === '/payment-policy' ? 'opacity-100 color-secondary' : ''}`}>
              <Link href={'/payment-policy'}>30 Day Guarantee</Link>
            </div>
            <div className={`mb-[10px] xl:mb-[0px] ${currentPath === '/privacy-policy' ? 'opacity-100 color-secondary' : ''}`}>
              <Link href={'/privacy-policy'}>Privacy Policy</Link>
            </div>
            <div className={`mb-[10px] xl:mb-[0px] ${currentPath === '/terms-of-service' ? 'opacity-100 color-secondary' : ''}`}>
              <Link href={'/terms-of-service'}>Terms and Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
